<!-- https://www.figma.com/file/hZ14djvbx5qYuIJwSU7moW/%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B-%F0%9F%94%A5?node-id=746%3A77517&t=Q2DTBoHufVMCUMUK-1 -->
<template>
  <div class="insert">
    <slot />
  </div>
</template>

<script lang="ts">
  export default defineNuxtComponent({
    name: 'BaseInsert',
  });
</script>

<style lang="scss" scoped>
  .insert {
    color: $mainBlack;
    font-weight: 500;
    font-family: $text-font--1;
    @include mediumText;
    border-radius: 32px;
    padding: $spacing-6;
    width: 100%;
    border: 4px solid $border-color--1;
    position: relative;
    @include tablet {
      padding: $spacing-6 $spacing-10;
      @include extra-big-text;
    }

    .article-page & {
      margin-bottom: 24px;
    }

    :deep() a {
      @include link-styles;
    }
  }
</style>
